import { Pipe, PipeTransform } from '@angular/core';
import { getFormattedTime } from '../functions/get-formatted-time';
import { FormatTimeType } from '../types/format-time.type';

@Pipe({
  name: 'formatTime',
  standalone: true,
})
export class FormatTimePipe implements PipeTransform {
  transform(time: string | undefined | null, format: FormatTimeType = 'HH:mm'): string {
    return getFormattedTime(time, format);
  }
}
